export enum CsrQuotesTabsEnum {
  'Not Submitted' = 1,
  'Not Completed' = 9,
  'Completed',
  'All Quotes',
}
